import { CrimeType } from "../types/CrimeType";

export const CrimeTypeList: CrimeType[] = [
  {
    id: 0,
    title: "Rob a hot dog vendor",
    percentage: 30,
    image: "/assets/imgs/crime/crime_1.png",
  },
  {
    id: 1,
    title: "Rob a freight train",
    percentage: 14,
    image: "/assets/imgs/crime/crime_2.png",
  },
  {
    id: 2,
    title: "Rob the bank",
    percentage: 7,
    image: "/assets/imgs/crime/crime_3.png",
  },
  {
    id: 3,
    title: "Bribe the police station",
    percentage: 3,
    image: "/assets/imgs/crime/crime_4.png",
  },
];

export const NickCarTypeList: CrimeType[] = [
  {
    id: 0,
    title: "On the street corner",
    percentage: 30,
    image: "/assets/imgs/nickcar/1.jpg",
  },
  {
    id: 1,
    title: "At the football stadium",
    percentage: 14,
    image: "/assets/imgs/nickcar/2.png",
  },
  {
    id: 2,
    title: "From private residence",
    percentage: 7,
    image: "/assets/imgs/nickcar/3.png",
  },
  {
    id: 3,
    title: "From the dealership",
    percentage: 3,
    image: "/assets/imgs/nickcar/4.jpg",
  },
];
